import React from 'react'
import { Switch, Route, withRouter, Router, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import history from '../store/history'
import { getUserRole, isAuthenticated } from '../services/auth'
import {
  routes,
  defaultRoute,
  defaultAdminRoute,
  unauthorizedRoute,
  unauthorizedAdminRoute
} from './routePaths'
import { Roles } from '../constants/roles'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isAuthenticated()) {
        return (
          <Redirect
            to={{
              pathname: history.location.pathname.includes('/admin')
                ? unauthorizedAdminRoute.path
                : unauthorizedRoute.path,
              state: { from: history.location.pathname }
            }}
          />
        )
      }

      const userRole = getUserRole()
      if (props.location.pathname.includes('/admin')) {
        if (![Roles.ADMIN_ECBR, Roles.VIEWER_ECBR].includes(userRole)) {
          console.log('The user has no permission')
          return (
            <Redirect
              to={{
                // pathname: `${unauthorizedAdminRoute.path}?from=${encodeURI(
                //   history.location.pathname
                // )}&errMsgCode=1`,
                pathname: unauthorizedAdminRoute.path,
                state: { from: history.location.pathname }
              }}
            />
          )
        }

        return <Component {...props} />
      }

      if (
        ![Roles.ADMIN_USER, Roles.VIEWER_USER, Roles.PILLAR_OWNER].includes(
          userRole
        )
      ) {
        return (
          <Redirect
            to={{
              // pathname: `${unauthorizedRoute.path}?from=${encodeURI(
              //   history.location.pathname
              // )}&errMsgCode=1`,
              pathname: unauthorizedRoute.path,
              state: { from: history.location.pathname }
            }}
          />
        )
      }

      return <Component {...props} />
    }}
  />
)

PrivateRoute.propTypes = {
  component: PropTypes.func
}

const Routes = () => {
  return (
    <Router history={history}>
      <Switch>
        {/* By default all routes are private */}
        {routes
          .filter(({ text, redirect }) => !text && !redirect)
          .map(({ id, path, name, component, isPrivate }) =>
            isPrivate === false ? (
              <Route
                key={id}
                exact
                path={path}
                pathname={name}
                component={component}
              />
            ) : (
              <PrivateRoute
                key={id}
                exact
                path={path}
                pathname={name}
                component={component}
              />
            )
          )}
        {/* Redirects */}
        {routes
          .filter(({ redirect }) => Boolean(redirect))
          .map(({ id, path, redirect }) => (
            <Route
              key={id}
              path={path}
              render={() => <Redirect to={redirect} />}
            />
          ))}
        {/* Redirect to default routes */}
        <Redirect
          to={
            history.location.pathname.includes('/admin')
              ? defaultAdminRoute.path
              : defaultRoute.path
          }
        />
      </Switch>
    </Router>
  )
}

export default withRouter(Routes)
